import { EnumSurveyAnswerStatus } from "../../Common/Enums/EnumsTypes";
import images from "../../ImageVariables";
import { NoteAndGuidancePropsTypes } from "../NoteAndGuidancePropsTypes";
import "../SCSS/styles.css";
export default function NoteAndGuidance({
  surveyAnswersInfo,
  handleNextPage,
}: NoteAndGuidancePropsTypes) {
  const notes = surveyAnswersInfo?.surveyInfo?.additionalInfo?.note.split("\n");
  return (
    <div className="mobile-supplier-additional-info-main-container">
      <div className="mobile-supplier-additional-info-inner-container">
        <div className="mobile-supplier-additional-info-heading-cover">
          <h4 className="heading-text">
            {surveyAnswersInfo?.surveyInfo?.surveyName}
          </h4>
        </div>
        <div className="mobile-supplier-view-survey-additional-info-description-cover">
          <div className="mobile-supplier-view-survey-additional-info-description-wrapper">
            <p className="mobile-supplier-view-survey-additional-info-description-text">
              {surveyAnswersInfo?.surveyInfo?.additionalInfo?.description}
            </p>
          </div>
        </div>
        <div className="mobile-supplier-view-survey-note-and-guidance-wrapper">
          <div className="mobile-note-cover">
            <div className="mobile-note-wrapper">
              <div className="guidance-header">Note & Guidance</div>
              <div className="rules">
                {notes?.map((ele) => {
                  return (
                    <>
                      <div className="lines">{ele}</div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      {surveyAnswersInfo.surveyStatus !== EnumSurveyAnswerStatus.COMPLETED && (
        <div className="supplier-next-btn-cover">
          <div className="contact-next-button">
            <div className="next-button">
              <div className="button" onClick={() => handleNextPage(true)}>
                {surveyAnswersInfo?.surveyStatus === "pending" ? (
                  <span>Next</span>
                ) : (
                  <span>Start Assessment</span>
                )}
                <span className="arrow">
                  <img src={images.whiteArrow} alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
